import {
  ExclamationCircleOutlined,
  EyeOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { Button, Collapse, Image } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';
import { CategoryEnum, FloorPlan } from '../../../__generated__/graphql';
import { AppContext } from '../../../AppContext';
import { isMobileBrowser, isTabletBrowser } from '../../../common/utils';
import { AppContextType } from '../../../types/appContext.type';
import { HeaderData } from '../../../types/vastuIssueReport.type';
import ShareFeedbackModal from './ShareFeedbackModal';

//Import css
import '../styles/vastuReportHeader.less';
import '../styles/vastuReportPage.less';

//Import Image
import PlaceHolder_Image from '../../../assets/images/image-placeholder.png';
import AddDetailsModal from './AddDetailsModal';
import DownloadSharePdf from './DownloadSharePdf';

export default function VastuReportHeader() {
  const {
    state: { floorPlan },
  } = useContext(AppContext) as AppContextType;
  const [headerData, setHeaderData] = useState<HeaderData>();
  const { width } = useWindowSize();
  const [isFeedbackModalOpen, setFeedbackModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (floorPlan) {
      setHeaderData(floorPlan as HeaderData);
    }
  }, []);

  const handlefeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  const ImagePreviewButton = ({
    category,
    label,
  }: {
    category: CategoryEnum;
    label: string;
  }) => {
    const [visible, setVisible] = useState<boolean>(false);
    const imageSrc =
      headerData?.assets?.find((asset) => asset?.category === category)?.key ??
      PlaceHolder_Image;

    return (
      <div>
        <div>{label}</div>
        {/* Mobile view preview button */}
        {isMobileBrowser(width) && (
          <div>
            <Button
              type="primary"
              onClick={() => setVisible(true)}
              icon={<EyeOutlined />}
            >
              Show Image Preview
            </Button>
            <Image
              width={170}
              style={{ display: 'none' }}
              src={imageSrc}
              preview={{
                visible,
                onVisibleChange: (value) => setVisible(value),
              }}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="floor-plan-detection-header">
        <div className="detection-header-details">
          <div className="detection-header-title">
            {!isMobileBrowser(width) && (
              <div className="floor-plan-name">
                <strong>Plan Name : </strong>
                <span>{headerData?.name}</span>
              </div>
            )}
            {!isMobileBrowser(width) && (
              <div className="floor-number">
                <strong>Floor Number : </strong>
                <span>{headerData?.floorNumber}</span>
              </div>
            )}
          </div>
          <div className="detection-header-title">
            {!isMobileBrowser(width) && (
              <div className="floor-number">
                <strong>Property Type : </strong>
                <span>{headerData?.propertyType}</span>
              </div>
            )}

            {!isMobileBrowser(width) && (
              <div
                className="floor-number"
                onClick={() => setDetailsModalOpen(true)}
              >
                <Button>
                  <span className="additional-text">
                    <PlusOutlined className="mr-2" /> Enter More Details
                  </span>
                </Button>
              </div>
            )}
          </div>
          <div className="actions-div">
            <div className="issue-feedback-wrapper">
              <ShareFeedbackModal
                modalOpen={isFeedbackModalOpen}
                onClose={handlefeedbackModalClose}
                floorPlanid={headerData?.id || ''}
              ></ShareFeedbackModal>
              <Button
                type="primary"
                className="issue-feedback-btn "
                onClick={() => {
                  setFeedbackModalOpen(true);
                }}
                icon={<ExclamationCircleOutlined />}
              >
                {isTabletBrowser(width) && 'Report Issue'}
              </Button>

              {isMobileBrowser(width) && (
                <Button
                  type="primary"
                  onClick={() => setDetailsModalOpen(true)}
                  className="issue-feedback-btn"
                  icon={<PlusOutlined />}
                >
                  <span className="additional-text"> Enter Details</span>
                </Button>
              )}
            </div>

            <div className="width-percent-50">
              {isTabletBrowser(width) && (
                <div>
                  <DownloadSharePdf />
                </div>
              )}
            </div>
          </div>
        </div>
        <Collapse
          className="collapse"
          expandIconPosition="end"
          items={[
            {
              key: '1',
              label: (
                <div>
                  {!isMobileBrowser(width) && (
                    <div>Get North Direction & Entrance Image Preview</div>
                  )}
                  {isMobileBrowser(width) && (
                    <div className="floor-plan-name">
                      <strong>Plan Name : </strong>
                      <span>{headerData?.name}</span>
                    </div>
                  )}
                </div>
              ),
              children: (
                <>
                  <div className="detection-header-title-mobile-view">
                    {isMobileBrowser(width) && (
                      <div className="floor-number-mobile-view">
                        <strong>Floor Number : </strong>
                        <span>{headerData?.floorNumber}</span>
                      </div>
                    )}
                    {isMobileBrowser(width) && (
                      <div className="property-type-mobile-view">
                        <strong>Property Type : </strong>
                        <span>{headerData?.propertyType}</span>
                      </div>
                    )}
                  </div>
                  <div className="image-conatiner">
                    <div className="north-direction-image">
                      {/* Mobile view preview button start */}
                      <ImagePreviewButton
                        category={CategoryEnum.NorthDirected}
                        label="Selected North Direction"
                      />
                      {/* Mobile view preview button end */}
                      {/* Desktop Image end */}
                      {!isMobileBrowser(width) && (
                        <img
                          src={
                            headerData?.assets?.find(
                              (asset) =>
                                asset?.category === CategoryEnum.NorthDirected,
                            )?.key ?? PlaceHolder_Image
                          }
                          alt="Image"
                        />
                      )}
                      {/* Desktop Image end */}
                    </div>
                    <div className="entrance-selected-image">
                      {/* Mobile view preview button start */}
                      <ImagePreviewButton
                        category={CategoryEnum.Entrance}
                        label="Selected Entrance Direction"
                      />
                      {/* Mobile view preview button end */}
                      {/* Desktop Image start */}
                      {!isMobileBrowser(width) && (
                        <img
                          src={
                            headerData?.assets?.find(
                              (asset) =>
                                asset?.category === CategoryEnum.Entrance,
                            )?.key ?? PlaceHolder_Image
                          }
                          alt="Image"
                        />
                      )}
                      {/* Desktop Image end */}
                    </div>
                  </div>
                </>
              ),
            },
          ]}
        />
      </div>
      <AddDetailsModal
        floorPlan={headerData as FloorPlan}
        setDetailsModalOpen={setDetailsModalOpen}
        open={detailsModalOpen}
      />
    </>
  );
}
